export default __webpack_public_path__ + "static/media/icon_joy_no_alarm.e757ed1c.svg";